import { makeStyles } from "@material-ui/core/styles";
import { MasterButton } from "App/Component/ui";
import { BASE_URL_WMS_BPJS, instance1, instance2, V1 } from "App/constants";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";
import { defaultToastError, isNull } from "App/utils/helpers";
import { useState, useEffect } from "react";
import { itSelfEmpty } from "utils/all";
import { LIST_URL_MASTER } from "utils/masters";

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "nik",
    disablePadding: false,
    label: "NIP",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "id_user",
    disablePadding: false,
    label: "USER",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "id_ihs",
    disablePadding: false,
    label: "ID IHS",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tipe_tenaga_medis",
    disablePadding: false,
    label: "TIPE TENAGA MEDIS",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "gender",
    disablePadding: false,
    label: "JENIS KELAMIN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "agama",
    disablePadding: false,
    label: "AGAMA",
    align: "left",
  },
  {
    id: "no_telepon",
    disablePadding: false,
    label: "NO. TELEPON",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tgl_sip",
    disablePadding: false,
    label: "TANGGAL MULAI KERJA",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "left",
  },
  {
    id: "no_sip",
    disablePadding: false,
    label: "No. SIP",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tgl_sip",
    disablePadding: false,
    label: "TANGGAL TERBIT SIP",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "no_str",
    disablePadding: false,
    label: "No. STR",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tgl_str",
    disablePadding: false,
    label: "TANGGAL EXP STR",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "spesialis",
    disablePadding: false,
    label: "CODE SPESIALIS",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "spesialisName",
    disablePadding: false,
    label: "SPESIALIS",
    align: "left",
  },
  {
    id: "kualifikasi",
    disablePadding: false,
    label: "KUALIFIKASI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "poli",
    disablePadding: false,
    label: "POLI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    minWidth: "200px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    minWidth: "200px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    minWidth: "200px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    minWidth: "200px",
  },
];

export const RESET_STATE_FORM_DATA = {
  // id: "",
  fullname: "",
  id_user: null,
  username: "",
  id_ihs: "",
  id_user_nama: "Pilih User",
  tipe_tenaga_medis: null,
  tipe_tenaga_medis_nama: "Pilih Tipe Tenaga Medis",
  spec_code: null,
  spec_name: "Pilih Spesialis",
  nik: "",

  poliklinik_id: null,
  poliklinik_name: "Pilih Poliklinik",

  hospital_code: "",
  // user_id: 1,

  dp_place: "",
  dp_date: "",
  dp_religion: "",
  dp_gender: "1",
  dp_mobilephone: "",
  dp_phone: "",
  dp_email: "",
  dp_nik: "",
  dp_npwp: "",
  dp_region: "",
  dp_keahlian_khusus: "",
  dp_firstdoctordate: "",

  edu_qualified: "",
  edu_bachelor: "",
  edu_diploma: "",
  edu_doctor: "",
  kj_establish_date: "",
  kj_expired_date: "",
  kj_str_number: "",
  no_sep: "",
  tgl_sip: "",
  bk_bank: null,
  bk_bank_name: "Pilih Bank",
  bk_norek: "",
  qualification_name: "Pilih Kualifikasi",

  dokter_name: "",
  kj_bpjsbridge: "",
  kj_bpjsbridge_name: "Pilih Dokter Bridge",

  // fk_photo: "",
  // fk_ttd: "",

  // photo_link: "",
  // ttd_link: "",
  inisial: "",
  status: 1,
  remark: "-",
};

export const FORM_FILTER_DOKTER = {
  name: "",
  poliklinik_id: "",
  spec_code: "",
  hospital_code: "",
  id_satu_sehat: "",
  tipe_tenaga_medis: "",
  tipe_tenaga_medis_nama: "Pilih Itipe Tenaga Medis",
  id_jasa: "",
  status: "",
  pages: 1,
  limit: 10,
};

export const FORM_FILTER_SYNC = {
  pages: 1,
  limit: 10,
};

export const validationInputDokter = (data) => {
  const {
    fullname,
    nik,
    id_user,
    tipe_tenaga_medis,
    poliklinik_id,
    hospital_code,
    dp_date,
    dp_place,
    dp_religion,
    inisial,
    dp_nik,
    dp_firstdoctordate,
    kj_establish_date,
    kj_expired_date,
    tgl_sip,
    spec_code,
    edu_qualified,
    bk_bank,
    no_sep,
  } = data;

  if (fullname === "") {
    return defaultToastError("Nama Dokter tidak boleh kosong");
  } else if (isNull(nik)) {
    return defaultToastError("No Induk Pegawai tidak boleh kosong");
  } else if (isNull(id_user)) {
    return defaultToastError("User tidak boleh kosong");
  } else if (isNull(tipe_tenaga_medis)) {
    return defaultToastError("Tipe Tenaga Medis tidak boleh kosong");
  } else if (spec_code === "") {
    return defaultToastError("Spesialis tidak boleh kosong");
  } else if (isNull(poliklinik_id)) {
    return defaultToastError("Poliklinik tidak boleh kosong");
  } else if (isNull(hospital_code)) {
    return defaultToastError("Rumah Sakit tidak boleh kosong");
  } else if (isNull(dp_place)) {
    return defaultToastError("Tempat Lahir tidak boleh kosong");
  } else if (isNull(dp_date)) {
    return defaultToastError("Tanggal Lahir tidak boleh kosong");
  } else if (isNull(dp_religion)) {
    return defaultToastError("Agama tidak boleh kosong");
  } else if (isNull(inisial)) {
    return defaultToastError("Inisial Dokter tidak boleh kosong");
    //   } else if (inisial.length < 1) {
    //     return defaultToastError("Inisial Dokter minimal 2 karakter");
  } else if (inisial.length > 3) {
    return defaultToastError("Inisial Dokter maksimal 3 karakter");
  } else if (isNull(dp_nik)) {
    return defaultToastError("NIK tidak boleh kosong");
    // } else if (isNull(dp_firstdoctordate)) {
    //   return defaultToastError("Tanggal Awal Menjadi Dokter tidak boleh kosong");
    // } else if (edu_qualified === "") {
    //   return defaultToastError("Kualifikasi Pendidikan tidak boleh kosong");
    // } else if (isNull(kj_establish_date)) {
    //   return defaultToastError("Tanggal Mulai Kerja tidak boleh kosong");
    // } else if (isNull(kj_expired_date)) {
    //   return defaultToastError("Tanggal Habis STR tidak boleh kosong");
    // } else if (isNull(no_sep)) {
    //   return defaultToastError("No SIP tidak boleh kosong");
    // } else if (isNull(tgl_sip)) {
    //   return defaultToastError("Tanggal Terbit SIP tidak boleh kosong");
    // } else if (bk_bank === "") {
    //   return defaultToastError("Bank tidak boleh kosong");
  } else {
    return true;
  }
};

export const STYLE_MANAJEMEN_DOKTER = makeStyles({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  inputButton: {
    borderRight: "1px solid #EAEAEA",
    borderTop: "1px solid #EAEAEA",
    borderBottom: "1px solid #EAEAEA",
    borderLeft: "0",
    background: "#fff",
    padding: "0 0.8rem",
    cursor: "pointer",
    borderRadius: "0 6px 6px 0",
  },
  label: {
    fontWeight: 400,
    color: "#BDBDBD",
    fontSize: "11px",
  },
  radioButton: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginTop: "0.5rem",
  },
});

export const getAllDokter = async (
  formFilter,
  pages,
  limit,
  url = LIST_URL_MASTER.dokter.list
) => {
  try {
    const api = await instance1.get(url, {
      params: {
        name: formFilter.name,
        poliklinik_id: formFilter.poliklinik_id,
        spec_code: formFilter.spec_code,
        hospital_code: formFilter.hospital_code,
        id_jasa: formFilter?.id_jasa,
        id_satu_sehat: formFilter?.id_satu_sehat,
        tipe_tenaga_medis: formFilter?.tipe_tenaga_medis,
        status: formFilter?.status,
        pages,
        limit,
      },
    });
    const res = api.data;
    return {
      state: true,
      data: res.body,
      meta: res?.meta,
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const exportAllDokter = async (
  formFilter,
  url = LIST_URL_MASTER.dokter.export
) => {
  try {
    const api = await instance1.get(url, {
      params: {
        name: formFilter.name,
        poliklinik_id: formFilter.poliklinik_id,
        spec_code: formFilter.spec_code,
        hospital_code: formFilter.hospital_code,
        id_jasa: formFilter?.id_jasa,
        id_satu_sehat: formFilter?.id_satu_sehat,
        tipe_tenaga_medis: formFilter?.tipe_tenaga_medis,
        status: formFilter?.status,
      },
    });
    const res = api.data;
    return {
      state: true,
      data: res.body,
      meta: res?.meta,
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getAllDokterSmall = async (
  formFilter,
  pages,
  limit,
  url = LIST_URL_MASTER.dokter.list
) => {
  try {
    const api = await instance1.get(url, {
      headers: {
        name: formFilter.name,
        poliklinik_id: formFilter.poliklinik_id,
        spec_code: formFilter.spec_code,
        hospital_code: formFilter.hospital_code,
        id_jasa: formFilter?.id_jasa,
        id_satu_sehat: formFilter?.id_satu_sehat,
        tipe_tenaga_medis: formFilter?.tipe_tenaga_medis,
        status: formFilter?.status,
        pages,
        limit,
      },
    });
    const res = api.data;
    return {
      state: true,
      data: res.body,
      meta: res?.meta,
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getDokterById = async (id) => {
  try {
    const api = await instance1.get(LIST_URL_MASTER.dokter.by_id, {
      headers: {
        iddoctor: id,
      },
    });

    return {
      state: true,
      data: api?.data?.body[0],
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getKtpDokterById = async (id) => {
  try {
    const api = await instance1.get(
      `${LIST_URL_MASTER.dokter.ktp_by_id}/${id}`
    );

    return {
      state: true,
      data: api?.data?.body[0],
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deleteDokterById = async (id) => {
  try {
    const res = await instance1.post(
      LIST_URL_MASTER.dokter.delete,
      {},
      {
        headers: {
          iddoctor: id,
        },
      }
    );
    return {
      state: true,
      data: res?.data?.body,
      meta: res?.data?.meta,
      message: "Berhasil menghapus dokter",
    };
  } catch (error) {
    return {
      state: false,
      data: [],
      message: error?.response?.data?.message,
    };
  }
};

export const newFormData = (data, photo, ttd) => {
  const formData = new FormData();

  formData.append("fullname", data.fullname);
  formData.append("tipe_tenaga_medis", data.tipe_tenaga_medis);
  formData.append("spec_code", data.spec_code);

  // formData.append("user_id", "1");
  formData.append("dp_place", data.dp_place);
  formData.append("dp_date", data.dp_date);

  if (data.dp_religion !== null && data.dp_religion !== "") {
    formData.append("dp_religion", data.dp_religion);
  }

  if (data.dp_gender !== null && data.dp_gender !== "") {
    formData.append("dp_gender", data.dp_gender);
  }

  if (data.dp_mobilephone !== null && data.dp_mobilephone !== "") {
    formData.append("dp_mobilephone", data.dp_mobilephone);
  }

  if (data.dp_phone !== null && data.dp_phone !== "") {
    formData.append("dp_phone", data.dp_phone);
  }

  if (data.dp_email !== null && data.dp_email !== "") {
    formData.append("dp_email", data.dp_email);
  }

  if (data.dp_nik !== null && data.dp_nik !== "") {
    formData.append("dp_nik", data.dp_nik);
  }

  if (data.dp_npwp !== null && data.dp_npwp !== "") {
    formData.append("dp_npwp", data.dp_npwp);
  }

  if (data.dp_region !== null && data.dp_region !== "") {
    formData.append("dp_region", data.dp_region);
  }

  if (data.edu_bachelor !== null && data.edu_bachelor !== "") {
    formData.append("edu_bachelor", data.edu_bachelor);
  }

  if (data.edu_diploma !== null && data.edu_diploma !== "") {
    formData.append("edu_diploma", data.edu_diploma);
  }

  if (data.edu_doctor !== null && data.edu_doctor !== "") {
    formData.append("edu_doctor", data.edu_doctor);
  }
  if (data.edu_qualified !== null && data.edu_qualified !== "") {
    formData.append("edu_qualified", data.edu_qualified);
  }

  if (data.kj_establish_date !== null && data.kj_establish_date !== "") {
    formData.append("kj_establish_date", data.kj_establish_date);
  }
  if (data.kj_expired_date !== null && data.kj_expired_date !== "") {
    formData.append("kj_expired_date", data.kj_expired_date);
  }
  if (data.bk_bank !== null && data.bk_bank !== "") {
    formData.append("bk_bank", data.bk_bank);
  }
  if (data.kj_str_number !== null && data.kj_str_number !== "") {
    formData.append("kj_str_number", data.kj_str_number);
  }
  if (data.kj_bpjsbridge !== null && data.kj_bpjsbridge !== "") {
    formData.append("kj_bpjsbridge", data.kj_bpjsbridge);
  }
  if (data.bk_norek !== null && data.bk_norek !== "") {
    formData.append("bk_norek", data.bk_norek.toString());
  }
  if (photo !== null && photo !== "") {
    formData.append("fk_photo", photo);
  }
  if (ttd !== null && ttd !== "") {
    formData.append("fk_ttd", ttd);
  }

  // Required

  formData.append("status", data.status);
  formData.append("remark", "-");

  return formData;
};

export const getDataBridge = async () => {
  try {
    const api = await instance1.get(`/bridging`, {
      headers: {
        method: "get",
        url: `${BASE_URL_WMS_BPJS}/${V1}/rsannisa/ws/bpjs/referensi/dokter`,
      },
    });
    if (api.data.body.response?.list.length > 0) {
      return {
        state: true,
        data: api.data.body.response?.list,
      };
    }

    return {
      state: true,
      data: [],
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    };
  }
};

export const useDokterBridge = (nama_dokter) => {
  const DEFAULT_OPTION = [];
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState(DEFAULT_OPTION);
  useEffect(() => {
    (async () => {
      if (!isNull(nama_dokter)) {
        setLoading(true);
        const res = await getDataBridge(nama_dokter);
        if (res.state) {
          const data = [];
          res.data.map((item) => {
            return data.push({
              value: item.kode,
              label: item.nama,
            });
          });

          setState(data);
          setLoading(false);
        } else {
          setLoading(false);
          setState([]);
        }
      } else {
        setState([]);
      }
    })();
  }, [nama_dokter]);

  return {
    dokterList: state,
    dokterLoading: loading,
  };
};

export const RenderStatusDokter = ({ status }) => {
  if (status === true) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"AKTIF"}
        color={"green"}
        type="button"
        disabled
      />
    );
  } else if (status === false) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"TIDAK AKTIF"}
        color={"secondary"}
        type="button"
        disabled
      />
    );
  } else {
    return <p> Tidak ditemukan</p>;
  }
};

export const TIPE_TENAGA_MDIS = [
  {
    label: "Dokter",
    value: "Dokter",
  },
  {
    label: "Perawat",
    value: "Perawat",
  },
  {
    label: "Bidan",
    value: "Bidan",
  },
  {
    label: "Apoteker",
    value: "Apoteker",
  },
  {
    label: "TKK",
    value: "TKK",
  },
  {
    label: "Radiografer",
    value: "Radiografer",
  },
  {
    label: "Petugas Lab",
    value: "Petugas Lab",
  },
  {
    label: "Ahli Gizi",
    value: "Ahli Gizi",
  },
  {
    label: "Fisioterapis",
    value: "Fisioterapis",
  },
];

export const getListMonitoringSyncIHS = async (pages, limit) => {
  // console.log("first");
  try {
    const api = await instance2.get(
      "/practitioner/monitoring_syncron_satu_sehat",
      {
        params: {
          limit: limit,
          pages: pages,
        },
      }
    );
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: itSelfEmpty(res.body?.data, []),
        proses: itSelfEmpty(res.body?.proses, []),
        meta: res.meta,
      };
    } else {
      return {
        state: false,
        data: [],
        message: res.message,
        meta: {
          count: 0,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      data: [],
      message: error?.response?.data?.message,
      meta: {
        count: 0,
      },
    };
  }
};

export const sync = async () => {
  try {
    const api = await instance2.post("/practitioner/syncron_satu_sehat");
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: res.message,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCellsSync = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    sort: false,
  },
  {
    id: "fullname",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "200px",
    sort: false,
  },
  {
    id: "nik",
    disablePadding: false,
    label: "NIK",
    align: "left",
    minWidth: "100px",
    sort: false,
  },
  // {
  //   id: "id_ihs",
  //   disablePadding: false,
  //   label: "ID IHS",
  //   align: "left",
  //   minWidth: "100px",
  //   sort: false,
  // },
];
